import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import HybridBasicLayout from '../../layout/basic/hybrid.basic.layout.vue';
import StackedOverflow from '../../../shared/StackedOverflow/stacked.overflow.vue';
import ASpaceInBetweenAnother from '../../../shared/ASpaceInBetweenAnother/a.space.inbetween.another.vue';
import { CommonConfig } from '../../../configs/config.common';
import HybridButtonOne from '../../../hybrid/shared/HybridButtonOne/HybridButtonOne.vue';
import GoBackArrow from '../../shared/GoBackArrow/go.back.arrow.vue';
import { UserInfoDelegate } from '../../services/DataDelegate/UserDelegate/user.info.delegate';
import * as T_T from 'cryface';
import { AxiosPromise } from '../../../utils/axios.promise';
import * as moment from 'moment';
import { getCondition } from '../../../utils/price.condition';
@Component({
    components: {
        'layout': HybridBasicLayout,
        StackedOverflow,
        ASpaceInBetweenAnother,
        HybridButtonOne,
        GoBackArrow
    },
})
export default class HybridCouponShare extends Vue {

    public configs = new CommonConfig();

    public img = '';

    public title = '';

    public subtitle = '';

    public price = 0;

    public priceInfo = '';

    public expiryDate = '';

    public fjjUserId: any = null;

    public respartnerId: any = null;

    public couponIns: any = null;

    public userInfoDelegate = new UserInfoDelegate();

    public customerServiceCall = this.configs.rifoContactPhone;

    public loading = true;

    @Watch('globalPudge', { immediate: true, deep: true })
    public async onEpicContext(val: any, oldVal: any) {
        // if (T_T.simpleDetect(val.context)) {
        //     const fjjUserId = val.getParam('fjjUserId');
        //     if (T_T.simpleDetect(fjjUserId)) {
        //         this.fjjUserId = fjjUserId;
        //         const userInfo = await this.userInfoDelegate.getUserInfo(this.fjjUserId);
        //         this.respartnerId = userInfo.resPartnerId;
        //         if (!T_T.simpleDetect(this.respartnerId)) {
        //             alert(
        //                 '账户信息异常，没有资源信息，请尽快联系客服 (416) 883-9666'
        //             );
        //         }
        //         this.refreshPageInfo(this.respartnerId);
        //         return;
        //     }
        // }
        this.refreshPageInfo(null);
    }
    public contents = [];

    public async created() {
    }
    public async refreshPageInfo(respartnerId: any) {
        const id = this.$route.params['id'];
        const apiHost = this.configs.couponService;
        const url = !respartnerId ?
            `${apiHost}/coupon/detailwithIns?couponId=${id}`
            : `${apiHost}/coupon/detailwithIns?couponId=${id}&partnerId=${respartnerId}`;
        const fetched = await AxiosPromise.get(url);
        if (fetched.errorCode === 200) {
            const data = fetched.data;
            const coupon = data.coupon;
            this.img = coupon.coverImgs[0];
            const language = T_T.simpleDetect(this.globalPudge.getParam('language')) ? this.globalPudge.getParam('language')!.value : 1;
            this.contents = language === 1 ? (T_T.simpleDetect(coupon.descEn) ? coupon.descEn : '') : (T_T.simpleDetect(coupon.descCn) ? coupon.descCn : '');
            const ins = data.ins;
            this.title = language === 1 ? (T_T.simpleDetect(coupon.xNameEn) ? coupon.xNameEn
                : this.$t('18')) : (T_T.simpleDetect(coupon.xNameCn) ? coupon.xNameCn : this.$t('18'));
            this.subtitle = T_T.simpleDetect(coupon.xTagline) ? coupon.xTagline : this.$t('19');
            this.price = T_T.simpleDetect(coupon.xPrice) ? coupon.xPrice : 0;
            this.expiryDate = T_T.simpleDetect(coupon.xExpiredDate) ? moment(new Date(coupon.xExpiredDate)).format(this.configs.dateFormat) : '';
            this.couponIns = ins;
            this.priceInfo = getCondition(
                coupon.xCategory,
                coupon.xDiscountPercent,
                coupon.xDiscountAmount,
                coupon.xRequestedAmount,
                this.$i18n.locale);
            // if (ins && ins.length) {
            //     this.status = ins[0].xStatus;
            // }
            this.loading = false;
        }

    }
    public async mounted() {
    }

    public getRifoAssets(path: string) {
        return `${this.configs.rifoDesignAssetsUrl}/${path}`;
    }

    public getButtonText() {
        return this.$t('29');
    }

    public nav() {
        // Go APP Store
    }
}
